import React, { useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';

import Nav from '../../components/Navigation/Nav';
import "../Landing/Landing.css"

const ViewBlogs = () => {
    const { blogName } = useParams();
    const BaseUrl=window.location.origin;

    const handleBlogs_1=()=>{
        window.open(BaseUrl+"/MeMyFolks Blog 1.1.pdf",'_blank').focus();
    }
    const handleBlogs_2=()=>{
        window.open(BaseUrl+"/Moments and Memories Blog.pdf",'_blank').focus();
    }
    const handleBlogs_3=()=>{
        window.open(BaseUrl+"/Safety and Security Blog.pdf",'_blank').focus();
    }
    return (
        
        <div >
            <Nav />
            <div className='indent-all'>
            <ol>
            <a href="javascript:;" onClick={handleBlogs_1}><li>MeMyFolks Blog 1.1</li></a>
            
            <a href="javascript:;" onClick={handleBlogs_2}><li>Moments and Memories Blog</li></a>
             <a href="javascript:;" onClick={handleBlogs_3}><li>Safety and Security Blog</li></a>
            </ol>
            </div>
        </div>
    );
};

export default ViewBlogs;
